<template>
  <div v-if="showNotification" class="update-notification">
    <div class="update-content">
      <div class="update-icon">
        <i class="fas fa-sync-alt"></i>
      </div>
      <div class="update-message">
        <h4>New Version Available!</h4>
        <p>A new version of the application is available. Please refresh to get the latest features and improvements.</p>
        <!-- <div class="version-info">
          <small>New version: {{ newVersion?.version }}</small>
        </div> -->
      </div>
      <div class="update-actions">
        <button @click="refreshNow" class="btn btn-primary btn-sm">
          <i class="fas fa-redo"></i> Refresh Now
        </button>
        <button @click="remindLater" class="btn btn-outline-secondary btn-sm">
          <i class="fas fa-clock"></i> Remind Later
        </button>
        <button @click="dismiss" class="btn btn-outline-danger btn-sm">
          <i class="fas fa-times"></i> Dismiss
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateNotification',
  props: {
    newVersion: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showNotification: false,
      remindLaterTimeout: null
    }
  },
  watch: {
    newVersion(newVal) {
      if (newVal) {
        this.showNotification = true;
        this.clearRemindLater();
      }
    }
  },
  methods: {
    refreshNow() {
      this.$emit('refresh');
    },
    remindLater() {
      this.showNotification = false;
      // Show again in 30 minutes
      this.remindLaterTimeout = setTimeout(() => {
        this.showNotification = true;
      }, 30 * 60 * 1000);
    },
    dismiss() {
      this.showNotification = false;
      this.clearRemindLater();
    },
    clearRemindLater() {
      if (this.remindLaterTimeout) {
        clearTimeout(this.remindLaterTimeout);
        this.remindLaterTimeout = null;
      }
    }
  },
  beforeUnmount() {
    this.clearRemindLater();
  }
}
</script>

<style scoped>
.update-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-left: 4px solid #007bff;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.update-content {
  padding: 20px;
}

.update-icon {
  text-align: center;
  margin-bottom: 15px;
}

.update-icon i {
  font-size: 24px;
  color: #007bff;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.update-message h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
}

.update-message p {
  margin: 0 0 10px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.version-info small {
  color: #999;
  font-size: 12px;
}

.update-actions {
  display: flex;
  gap: 8px;
  margin-top: 15px;
}

.btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-outline-secondary {
  background: transparent;
  color: #6c757d;
  border: 1px solid #6c757d;
}

.btn-outline-secondary:hover {
  background: #6c757d;
  color: white;
}

.btn-outline-danger {
  background: transparent;
  color: #dc3545;
  border: 1px solid #dc3545;
}

.btn-outline-danger:hover {
  background: #dc3545;
  color: white;
}

.btn-sm {
  font-size: 11px;
  padding: 4px 8px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .update-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
  }
  
  .update-actions {
    flex-direction: column;
  }
  
  .btn {
    justify-content: center;
  }
}
</style> 